<template>
  <section class="container">
    <div class="overflow-hidden bg-white shadow sm:rounded-lg my-28 md:my-48">
      <div class="px-4 py-5 sm:px-6">
        <h1
          class="text-2xl font-medium leading-6 text-center text-gray-900 lg:text-3xl md:text-left"
        >
          {{ $t("common.manuals") }}
        </h1>
      </div>
      <div class="border-t border-gray-200">
        <dl>
          <div
            v-for="(manual, index) in manuals"
            :key="index"
            class="px-4 py-5 odd:bg-gray-50 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6"
          >
            <dt
              class="mb-4 text-lg font-medium text-center text-gray-500 md:text-left md:mb-0"
            >
              {{ manual.name }}
            </dt>
            <dd
              class="flex flex-wrap justify-center mt-1 text-gray-900 md:justify-start gap-y-4 sm:mt-0"
            >
              <a
                v-for="(file, fileIndex) in manual.files"
                :key="fileIndex"
                :href="file.url"
                class="inline-flex items-center px-3 py-1 bg-white border rounded-md shadow-md hover:bg-primary-500 hover:text-white hover:no-underline focus:no-underline me-4"
                target="_blank"
                download
              >
                <img
                  class="inline h-6 me-2"
                  src="@/assets/svg/heroicons/document-download.svg"
                  :alt="$t('icon.download')"
                />
                {{ file.file_name }}
              </a>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();
const manuals = ref(null);

loadManuals();

async function loadManuals() {
  const { data } = await useAPI("api/front/manuals");

  if (data._rawValue && data._rawValue.data.length === 0) {
    console.log(data, "error");
  } else {
    manuals.value = data._rawValue.data;
  }
}
</script>
